export const SCORING_TYPES_VALUES = {
  API_SCORING: 0,
  BATCH_SCORING: 1,
  REGULAR_SCORING: 2,
  FORCED_CORING: 3,
};

export const scoringResultTypes = [
  {
    value: 0,
    label: "API",
  },
  {
    value: 1,
    label: "Batch",
  },
  {
    value: 2,
    label: "Regular",
  },
  {
    value: 3,
    label: "Forced",
  },
];

export const INITIAL_FILTERS_SCORING_RESULT_CONSTANTS = {
  dateFrom: "",
  dateTo: "",
  scoringType: "",
};

export const SCORING_RESULTS_FILTERS_LABELS = {
  dateFrom: "Date from:",
  dateTo: "Date to:",
  scoringType: "Scoring type:",
};



// WEBPACK FOOTER //
// ./src/features/reports/constants/scoringResultsReportConstants.js